module.exports = __webpack_public_path__ + "static/img/031治疗单-患者.2d628f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/031治疗单-患者.jpg
// module id = iMeV
// module chunks = 0